"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HoursLogModel = /** @class */ (function () {
    function HoursLogModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/hourslog",
            UPDATE: APPURL + "/api/v1/hourslog",
            CREATE: APPURL + "/api/v1/hourslog",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    HoursLogModel.prototype.extract = function (result) {
        return result.data;
    };
    HoursLogModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    HoursLogModel.prototype.getRequestByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    HoursLogModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    HoursLogModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    HoursLogModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    HoursLogModel.prototype.delete = function (entry) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + entry.id)
            .then(this.cacheResults);
    };
    return HoursLogModel;
}());
HoursLogModel.$inject = ["$http", "APPURL"];
exports.default = HoursLogModel;
